import React from 'react';
import { withTheme } from 'styled-components';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import LoaderSkelton from '@tcp/core/src/components/common/molecules/LoaderSkelton';
import style from '../styles/GetCandid.style';
import withStyles from '../../../hoc/withStyles';
import { getBrand } from '../../../../../utils';

const GetCandidSkeleton = (props) => {
  const { className } = props;
  const productImageSkeleton = [1, 2, 3, 4, 5];
  return (
    <section id="get-candid-container" className={`${className} brand-${getBrand()}`}>
      <Row centered>
        <Col
          colSize={{
            small: 6,
            medium: 8,
            large: 12,
          }}
        >
          <div className="get-candid-default-heading skeleton-candid-default-heading">
            <div className="get-candid-main-heading skeleton-candid-main-heading">
              <LoaderSkelton />
            </div>
            <div className="get-candid-heading-desc skeleton-candid-heading-desc">
              <LoaderSkelton />
            </div>
          </div>
        </Col>
      </Row>

      <Row centered>
        <Col
          colSize={{
            small: 6,
            medium: 8,
            large: 12,
          }}
          className="skeleton-candid-col-item-container"
        >
          <div className="skeleton-candid-item-container">
            {productImageSkeleton.map((item) => (
              <div className={`tcp-skeleton-candid-image-container item${-item}`} key={item}>
                <LoaderSkelton />
              </div>
            ))}
          </div>
        </Col>
      </Row>
      <Row centered>
        <div className="get-candid-button-container">
          <Col
            colSize={{
              small: 6,
              medium: 8,
              large: 12,
            }}
          >
            <div className="gallery-button-left skeleton-button-candid">
              <LoaderSkelton />
            </div>

            <div className="gellary-button-right skeleton-button-candid">
              <LoaderSkelton />
            </div>
          </Col>
        </div>
      </Row>
    </section>
  );
};

export default withStyles(withTheme(GetCandidSkeleton), style);
